





















import { Component, Prop, Vue } from "vue-property-decorator";

import { DateHelper } from "@/helper/dateHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { CloudAccount } from "@/cloudAccount/cloudAccount";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";

@Component({
  components: {
  }
})
export default class SnsModal extends Vue {
    
    title = "連携するSNSを選択してください";

    private get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private signIn(){
        this.$store.dispatch("setSignInToGo", "Sns");
        this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
        this.$router.push("/SignIn");
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
